**Max Drawdown** measures the maximum of all drawdown with reference over the time period analyzed.
